export const buildUddfData = (formDataWithTide, userObjectId) => {
  return {
    uddf: {
      generator: { name: "Diveproject", version: 0 },
      divesite: {
        site: {
          name: formDataWithTide.name,
          environment: formDataWithTide.environment,
          geography: {
            longitude: formDataWithTide.markerPosition.lng,
            latitude: formDataWithTide.markerPosition.lat,
            location: formDataWithTide.location,
            coordinates: {
              type: "Point",
              coordinates: [
                formDataWithTide.markerPosition.lng,
                formDataWithTide.markerPosition.lat,
              ],
            },
            address: {
              city: formDataWithTide.city,
              province: formDataWithTide.province,
              province_short: formDataWithTide.province_short,
              country: formDataWithTide.country,
              country_short: formDataWithTide.country_short,
            },
          },
          sitedata: {
            minimumdepth: formDataWithTide.depthRange[0],
            maximumdepth: formDataWithTide.depthRange[1],
          },
          shore: { notes: { para: formDataWithTide.diveDescription } },
          notes: { para: formDataWithTide.divesitePara },
        },
      },
      dive: {
        informationbeforedive: { platform: formDataWithTide.platform },
      },
    },
    metadata: {
      oneliner: "", // Assuming this is derived or not needed from formState directly
      media: { url: "" }, // Assuming this is derived or not needed from formState directly
      ratings: {
        overall: "", // Assuming this is derived or not needed from formState directly
        slog: formDataWithTide.slog,
        lastviz: { viz: 0, vizDate: new Date() }, // Placeholder values
      },
      additionalInfo: {
        surfaceSwimDistance: formDataWithTide.surfaceSwimDistance,
        closestTideStation: formDataWithTide.closestTideStation,
      },
      creator: userObjectId,
    },
  };
};
